export const SITE_URL = 'https://hoobuy.beauty';